import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

const COLS = [
  { title: "Product", links: ["Find Jobs", "Career Intelligence", "Career Profile", "ATS Checker", "Interview Copilot"] },
  { title: "Platform", links: ["Pricing", "Compare", "For Recruiters", "Application Autofill", "4-Language CV"] },
  { title: "Company", links: ["About", "Careers", "Blog", "Privacy", "Terms"] },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-border/60 bg-card/50">
      <div className="cv-container grid grid-cols-2 gap-8 py-16 md:grid-cols-5">
        <div className="col-span-2">
          <Logo />
          <p className="mt-4 max-w-xs text-sm text-muted-foreground">
            Career, Evolved. From CV to interview — one intelligent platform connecting global talent and opportunity.
          </p>
          <p className="mt-6 font-heading text-sm font-bold text-electric">CVOLVE PRO</p>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <p className="label-caps mb-4">{c.title}</p>
            <ul className="space-y-3">
              {c.links.map((l) => (
                <li key={l}>
                  <span className="cursor-pointer text-sm text-muted-foreground transition-colors hover:text-foreground">{l}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-border/60">
        <div className="cv-container flex flex-col items-center justify-between gap-3 py-6 sm:flex-row">
          <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} CVOLVE PRO. All rights reserved.</p>
          <p className="text-xs text-muted-foreground">Feature availability varies by plan and region.</p>
        </div>
      </div>
    </footer>
  );
}
